import { __t } from '@/lib/helpers'
import { ACCESS_LEVELS } from '@/lib/consts.ts'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'
import trialMode from '@/router/guards/trial-mode.ts'
import { defineAsyncComponent } from 'vue'

import { getSubRoutes } from '@/router/routes/business/settings/subscription.ts'

export default [
  {
    path: '/subscription-mobile',
    name: 'subscription-mobile',
    meta: {
      title: __t('routes.settings.subscription.title'),
      subtitle: __t('routes.settings.subscription.subtitle'),
      mobile: true,
      useSmartlook: true,
      [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    },
    component: defineAsyncComponent(() => import('@/views/subscription-mobile/views/index.vue')),
    children: [
      ...getSubRoutes({ mobile: true }),
    ],
    beforeEnter: trialMode(true),
  },
  {
    path: '/subscription-mobile-error',
    name: 'subscription-mobile-error',
    component: defineAsyncComponent(() => import('@/views/subscription-mobile/views/error.vue')),
  },
]
